import { makeStyles } from '@mui/styles';

export const useAddressStyle = makeStyles(() => ({
  buttonLink: {
    'text-transform': 'none',
    'white-space': 'pre',
    cursor: 'pointer',
  },
}));
